<template>
  <div :class="{ 'has-logo': true }">
    <!-- Logo -->
    <logo :collapse="isCollapse" />
    <div class="menu-con">
      <el-scrollbar
        :vertical="false"
        wrap-class="scrollbar-wrapper"
      >
        <!-- 菜单 -->
        <el-menu
          :collapse="isCollapse"
          :collapse-transition="false"
          :default-active="activeMenu"
          :unique-opened="false"
          mode="vertical"
        >
          <!-- 菜单项 -->
          <sidebar-item
            v-for="menu in menus"
            :key="menu.code"
            :base-path="menu.name"
            :item="menu"
          />
        </el-menu>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
// Logo
import Logo from "./Logo"
// 菜单项
import SidebarItem from "./SidebarItem"
import axios from 'axios'

export default {
  components: {
    SidebarItem,
    Logo
  },
  data() {
    return {
      menus: null
    }
  },
  computed: {
    ...mapGetters(["sidebar"]),
    // 获取所有路由

    // 获取当前路由路径，菜单ID为路径，故路径即为选中标签
    activeMenu() {
      const route = this.$route
      const { path } = route
      return path
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  watch: {
    menus(val, oldvalue) {
      this.menus = val
      localStorage.setItem("menudata", JSON.stringify(this.menus))
    }
  },
  created() {
    // 初始化菜单
    this.initMenu()
  },
  methods: {
    initMenu() {
      // 获取菜单清单
      const tModel = this.$store.getters['setting/getModel']
      if (tModel !== '100') {
        const self = this
        // axios.get('/data/menus/menu_admin.json')
        axios.get('/data/menus/menu.json')
          .then(result => {
            self.menus = result.data
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        this.menus = this.$store.getters['user/getMenus']
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";

::v-deep .scrollbar-wrapper {
  max-height: 95vh;
}

::v-deep .scrollbar-wrapper {
  padding: 16px 20px;
}

::v-deep .el-menu {
  background-color: $menuBg !important;
}

::v-deep .el-submenu__title {
  color: $menuText !important;
}

::v-deep .el-menu-item {
  color: $menuText;
}

::v-deep .el-menu-item.is-active {
  color: $menuActiveText;
}

::v-deep .router-link-active {
  width: 180px;
  height: 40px;
  background-color: $subMenuHover;
  border-radius: 4px;
}
</style>
